<template>
    <div class="my-login-container row flex-column flex-lg-row d-flex align-items-center justify-content-center justify-content-lg-between row-gap-3 row-gap-lg-0 px-1 px-sm-5">
        <h1 class="log-in-title-font large-box-shadow col-12 col-lg-6 text-center text-lg-start p-0">P-polls</h1>
        <div class="login-form-container px-4 py-5 col-12 col-sm-10 col-md-8 col-lg-6">
            <form class="login-form d-flex flex-column align-items-center row-gap-4" @submit.prevent="getAuthorization">
                <input type="email" required id="ID" name="ID" placeholder="email" v-model="loginFormValues.Email" class="primary-input extra-light-text">
                <input type="password" autucomplete="off" required id="password" name="password" placeholder="პაროლი" v-model="loginFormValues.password"  class="primary-input extra-light-text">
                <primaryButtonComponent :disabled="isSending" buttonType="submit" class="large-text mt-4">
                    <template v-slot:content>
                        ავტორიზაცია
                    </template>
                </primaryButtonComponent>
            </form>
        </div>
        
    </div>
</template>
<!-- <primaryModalComponent :showModal="showModal" maxHeight="500px" maxWidth="700px" @closeModal="closeModal" @click="closeModalFromBack">
    <template v-slot:modal-content>
        <form class="d-flex flex-column align-items-center row-gap-3 verification-form" @submit.prevent="loginInAction">
            <input type="text" required id="emailCode" name="emailCode" placeholder="კოდი" v-model="codeValue" class="primary-input extra-light-text">
            <primaryButtonComponent buttonType="submit" class="large-text mt-4">
                <template v-slot:content>
                    დადასტურება
                </template>
            </primaryButtonComponent>
        </form>
    </template>
</primaryModalComponent> -->
<script scoped>
import primaryButtonComponent from "@/components/primaryButtonComponent.vue"
import primaryModalComponent from "@/components/primaryModalComponent.vue"

export default {
    data(){
        return {
            // showModal: false,
            isSending: false,
            loginFormValues: {
                Email: "",
                password: "",
            },
            codeValue: "",
            testingVal: "",
        }
    },
    components: {
        primaryButtonComponent,
        primaryModalComponent,
    },
    beforeRouteUpdate(to, from, next){
        next(true);
    },
    methods: {
        checkEmail(){
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            let isValid = emailRegex.test(String(this.loginFormValues.Email));
            return isValid;
        },
        checkPassword(value){
            let isValid = /^(?=.*[A-Z]+)(?=.*[a-z]+)(?=.*\d+)(?=.*[!@#$%^&*()_+,\.]+)[A-Za-z\d!@#$%^&*()_+,\.]{8,}$/.test(value);
            return isValid;
        },
        async getAuthorization(){
            let isEmailValid = this.checkEmail();
            let isPasswordValid = this.checkPassword(String(this.loginFormValues.password));
            if(isEmailValid){ // && isPasswordValid
                this.isSending = true;
                await this.$store.dispatch("getAuthorization", {email: this.loginFormValues.Email, password: this.loginFormValues.password, fromRefresh: false});
                this.isSending = false;
            }else{
                this.$helper.initializeSwalWithoutTimer("არასწორი ფორმატი", "error", "", true);
            }
        },
        // loginInAction(){
        //     if(this.showModal){
        //     }
        // },
        // closeModal(Val){
        //     this.showModal = Val;
        //     this.codeValue = "";
        // },
    }
}

</script>
<style>
.my-login-container{
    width: 100%;
    height: 100dvh;
    max-width: 1920px;
    margin: 0 auto !important;
    background-color: var(--main-background-color);
    /* padding: 0 3em !important; */
}
.login-form-container{
    background-color: white;
    border-radius: 1em;
    border: 2px solid var(--light-blue);
    transition: all 0.3s linear;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 14px 24px 6px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
    max-width: 550px !important;
}
.log-in-title-font{
    font-size: 138px;
    line-height: 140px;
    letter-spacing: 0.1em;
    font-family: "firaGo-700";
}
.login-form .primary-input, .verification-form .primary-input{
    font-size: 15px;
    max-width: 350px;
    width: 100%;
    padding: 15px;
}
@media screen and (max-width: 1700px) {
    .log-in-title-font{
        font-size: 110px;
        line-height: 115px;
        letter-spacing: 0.1em;
        font-family: "firaGo-700";
    }
}
@media screen and (max-width: 576px) {
    .log-in-title-font{
        font-size: 70px;
        line-height: 80px;
        letter-spacing: 0.1em;
        font-family: "firaGo-700";
    }
}
@media screen and (max-width: 1260px) {
    .log-in-title-font{
        font-size: 90px;
        line-height: 95px;
        letter-spacing: 0.1em;
        font-family: "firaGo-700";
    }
}
</style>